<template>
    <div class="animated fadeIn arpaymfrm">        
        <b-card>
            <div slot="header">
                Form - Pembayaran Agen/Customer (Gabungan/Harian)
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
            <b-col lg="8">
                <b-row>
                    <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Payment Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.paymno" :state="!$v.model.paymno.$error"></b-form-input>
                        </b-input-group>
                    </b-col>   
                    <b-col lg="5">                            
                        <b-input-group >
                            <b-input-group-prepend><label>Payment Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tglpaym" type="date" :state="!$v.model.tglpaym.$error"></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                </b-row>                      
                <b-input-group >
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input  v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>
                </b-input-group>
                <b-row>
                    <b-col lg="8">
                    <b-input-group>
                        <b-input-group-prepend><label>Receipt From</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.custinfo" ></b-form-input>
                        <!-- <b-input-group-append>
                        <b-btn text="Button" @click="lkuCustomerShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append> -->
                    </b-input-group>
                    </b-col>
                    <b-col lg="4">      
                    <b-input-group >
                        <b-input-group-prepend><label style="width:70px;">Collector</label></b-input-group-prepend>
                        <b-form-select v-model="model.collector_id" :plain="true" :options="collectors" ></b-form-select>
                    </b-input-group>
                    </b-col>
                </b-row>                      

                <b-row>
                    <b-col lg="8">
                        <b-input-group >
                            <b-input-group-prepend><label>Payment Amount</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.totalbyr" :precision="2" :state="!$v.model.totalbyr.$error"></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">
                        <b-input-group >
                            <b-input-group-prepend><label>Exch. Rate {{model.matauang || ''}}</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{uanguser}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.kurstrx" :precision="6"></my-number>
                        </b-input-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="4">
                <v-dim :model="model" :key="updateDimHdr"></v-dim>
            </b-col>
            </b-row>   
            <label><strong>Detail Invoice Settlement</strong></label>
            <b-card no-body class="mt-0">
                <b-table
                    class="mb-0"
                    ref="tblArpaymdt"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="arpaymdt.items"
                    :fields="arpaymdt.fields"
                    :current-page="arpaymdt.page"
                    :per-page="arpaymdt.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaibyr)="data">
                        {{data.item.nilaibyr|numFormat}}
                        </template>
                        <template v-slot:cell(invdate)="data">
                        {{data.item.invdate| moment("MMM-YYYY")}}
                        </template>

                        <template v-slot:cell(kurskeAR)="data">
                        {{data.item.kurskeAR|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaibank)="data">
                        {{data.item.nilaibank|numFormat}}
                        </template>
                        <template v-slot:cell(kasdiskon)="data">
                        {{data.item.kasdiskon|numFormat}}
                        <div v-if="(data.item.Potongan)">{{data.item.Potongan}}</div>
                        </template>
                        <template v-slot:cell(selisihkurs)="data">
                        {{data.item.selisihkurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editArpaymdt(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delArpaymdt(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row align-h="around">
                            <b-col lg="6">
                                <b-input-group>
                                    <b-input-group-prepend><label>Agen/Customer</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="arpaymdtObj.custinfo" :state="!$v.arpaymdtObj.customerid.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuCustomerShow=true" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>

                                <b-row>
                                    <b-col lg="6">
                                        <b-input-group >
                                            <b-input-group-prepend><label>Tgl. Omset yg dibayar</label></b-input-group-prepend>
                                            <div>
                                                <vue-monthly-picker style="min-width:200px;" v-model="arpaymdtObj.invdate" :state="!$v.arpaymdtObj.invdate.$error" dateFormat="MMM YYYY" :monthLabels="monthLabels"></vue-monthly-picker>
                                            </div>
                                        </b-input-group>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-input-group >
                                            <b-input-group-prepend><label>Nilai Bayar</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="arpaymdtObj.nilaibyr" :precision="2" :state="!$v.arpaymdtObj.nilaibyr.$error"></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-input-group >
                                        <b-input-group-prepend><label>Cash Flow Account</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="arpaymdtObj.cashflow" @keyup.13.native="showLkuCashflow('arpaymdt')" :state="!$v.arpaymdtObj.kodecash.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="showLkuCashflow('arpaymdt')">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>Jenis Potongan</label></b-input-group-prepend>
                                    <b-form-select v-model="arpaymdtObj.IDPotongan" :plain="true" :options="potongans" :state="!$v.arpaymdtObj.IDPotongan.$error"></b-form-select>
                                    <b-input-group-prepend><span class="input-group-text">tarif (%)</span></b-input-group-prepend>
                                    <div style="display:inline; width:100px;">
                                        <b-form-input v-model="arpaymdtObj.tarif" type="number" @change="calcPotongan()" min="0" ></b-form-input>
                                    </div>
                                    <b-input-group-append><span class="input-group-text" style="width:100px !important;">%</span></b-input-group-append>
                                </b-input-group>
                                <b-row>
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label>Nilai Potongan</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="arpaymdtObj.kasdiskon" :precision="2" ></my-number>
                                            <b-input-group-prepend><span class="input-group-text">in Original Amt.</span></b-input-group-prepend>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                        <b-row >
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" @click="saveArpaymdt()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-row>

                            </b-col>
                        </b-row>                             
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-2">
                    <b-col lg="9">
                        <b-row >
                        <b-col cols="2">            
                            <b-button size="sm" class="ml-1" @click="addArpaymdt" >Add Settlement</b-button>                          
                        </b-col>
                        <b-col cols="10">
                            <div style="display: flex;margin:0;padding:0;">
                                <div style="margin:0;padding:5px;width:500px; text-align:right;">
                                    Showing {{(arpaymdt.page - 1) * arpaymdt.limit + 1}}
                                    to <span v-if="((arpaymdt.page * arpaymdt.limit)>arpaymdt.total)">{{arpaymdt.total}}</span> <span v-else>{{arpaymdt.page * arpaymdt.limit}}</span>
                                    of {{arpaymdt.total}} entries,   <span class="mr-1">limit per page :</span> 
                                    <select  v-model="arpaymdt.limit"  style="width:60px;">
                                    <option>5</option>
                                    <option>10</option>
                                    <option>15</option>
                                    <option>20</option>                            
                                    <option>25</option>
                                    <option>30</option>                            
                                    <option>40</option>                            
                                    <option>50</option>                            
                                    <option>60</option>                            
                                    <option>70</option>                            
                                    <option>80</option>                            
                                    <option>90</option>                            
                                    </select>
                                </div>
                                <div>
                                    <b-pagination  class="ml-1" 
                                    align="left"
                                    :total-rows="arpaymdt.total"
                                    :per-page="arpaymdt.limit"
                                    v-model="arpaymdt.page"
                                    ></b-pagination>
                                </div>
                            </div>
                        </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="3">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:170px !importnat;" >Total Detail Settlement</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="totalDtlPaym" :precision="2" disabled></my-number>
                            </b-input-group>
                    </b-col>
                </b-row>

            </b-card>    
            <b-row align-h="between">
                    <b-col lg="7">
                    <b-row>
                        <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Payment Method</label></b-input-group-prepend>
                            <b-form-select v-model="model.jenis" :plain="true" :options="jenisPaym" :state="!$v.model.jenis.$error"></b-form-select>                              
                        </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Due/Efective Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tgl_terima" type="date"  :state="!$v.model.tgl_terima.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>             
                    <b-row>
                        <b-col lg="6" v-if="((model.jenis==='Cheque') || (model.jenis==='Giro'))">
                            <b-input-group >
                                <b-input-group-prepend><label>Cheque/Giro No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomorcek" ></b-form-input>
                            </b-input-group>
                        </b-col>   
                        <b-col lg="6" v-if="((model.jenis==='Cheque') || (model.jenis==='Giro'))">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Cheque/Giro Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tgl_giro" type="date" ></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>             
                    <b-row >
                        <b-col lg="6" v-if="(model.jenis!='Tunai')">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer's BANK</label></b-input-group-prepend>
                                <b-form-input v-model="model.bankasal" ></b-form-input>
                            </b-input-group>
                        </b-col>   
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:150px;">Payment for AR Group</label></b-input-group-prepend>
                                <b-form-select v-model="model.artype" :plain="true" :options="arGroups" :state="!$v.model.artype.$error"></b-form-select>
                            </b-input-group>
                        </b-col>
                    </b-row>             
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><label>Finance Account</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.namabank" @keyup.13.native="lkuBankaccountShow=true" ></b-form-input>
                        <b-input-group-append>
                            <b-btn text="Button" @click="lkuBankaccountShow=true">
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                        <b-input-group-append>
                            <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group v-if="(this.model.isbank=='1')">
                        <b-input-group-prepend><label>Bank Account#</label></b-input-group-prepend>
                        <b-form-input disabled v-model="model.nomorrek" ></b-form-input>
                    </b-input-group>

                    <b-input-group v-if="(this.model.isbank=='1')">
                        <b-input-group-prepend><label>Bank Charges</label></b-input-group-prepend>
                        <b-input-group-prepend ><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                        <my-number class="form-control text-right" separator="," v-model="model.bcharges" :precision="2"></my-number>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                        <b-input-group-append class="ml-2">
                            <div class="text-right" >
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
        </b-card>
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
                <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData"></lku-cashflow>
        </b-modal>        
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
            <lku-bankaccount @click="onSelectLkuBankaccount" :formdata="lkuBankaccountData" aktif="1" ></lku-bankaccount>
        </b-modal>        
    </div>
</template>
<style lang="scss">
  .arpaymfrm {
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
  }
</style>

<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import toastr from "mini-toastr";
import moment from 'moment';
import dropdown from "../../data/dropdown";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCustomer from "../lookup/lkuKoranCust";
import arpayment from '../../apis/arkoranpaym';
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required,  minValue } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: {  VueMonthlyPicker, myNumber, vDim, lkuBankaccount,lkuCashflow,lkuCustomer},
  mixins: [validationMixin],
  validations: {
        model: {
            paymno: { required },
            uraian: { required },
            tglpaym: { required },
            jenis: { required },
            tgl_terima: { required:(function() {
                if ((this.model.jenis !=='Cheque') && (this.model.jenis !=='Giro')) {
                    return true;
                } else if (this.model.tgl_terima){
                    return true;
                } else return false;
            }) },
            artype: { required:(function() {
                if (this.model.settl_amt==this.model.totalbyr) {
                    return true;
                } else if (this.model.artype){
                    return true;
                } else return false;
            }) },
            matauang: { required },
            totalbyr: { required, minValue:minValue(0.01) },
            kurstrx: { required, minValue:minValue(0.00000001) }
        },
        arpaymdtObj :{
            customerid: { required },
            invdate: { required },
            nilaibyr: { minValue:(function() {
                if (this.adaPotongan) {
                    return true;
                } else if ((this.arpaymdtObj.nilaibyr || 0 )<0.01){
                    return false;
                } else return true;
            }) },
            IDPotongan : { required:(function() {
                if (!this.adaPotongan) {
                    return true;
                } else if ((this.arpaymdtObj.IDPotongan || '')==''){
                    return false;
                } else return true;                
            }) },
            kodecash : { required:(function() {
                if ((this.arpaymdtObj.nilaibank || 0) == 0) {
                    return true;
                } else if ((this.arpaymdtObj.kodecash || '')==''){
                    return false;
                } else return true;
            }) },
        },
  }, 
  data() {
    return {
        arGroups : [],collectors:[],
        currency:[{value:'IDR',text:'IDR'}],
        potongans:[],
        saveEnabled:true,
        horizontal:true,
        jenisPaym : ['Cheque', 'Giro', 'Transfer', 'Tunai'],
        model:{jenis:'Giro',kodecash:'',kodebank:'',kurstrx:1, customer_id:'Collection',CustCode:'Collection',custinfo:'Collection',
            tglpaym:moment().format('YYYY-MM-DD'),
            tgl_terima:'', matauang:'',totalbyr:'', custcode:'', settl_amt:0
            },
        inputBerlanjut: 0,
        inputLineBerlanjut: 1,
        lblExchRate:"Exch. Rate ",
        bankOnly:1,
        lkuBankaccountData:{},
        lkuBankaccountShow:false,
        lkuCashflowData:{},
        lkuCashflowShow: false,
        lkuCashflowCaller:'arpaymdt',        
        totalDtlPaym:0,
        updateDimHdr:false,
        updateDimDtl:true,
        arpaymdt: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "CustName",
                    label: "Agen/Customer Name",
                    sortable: true
                },
                {
                    key: "custcode",
                    label: "Code",
                    thStyle: "width:140px",
                    sortable: true
                },
                {
                    key: "invdate",
                    label: "Tgl. Omset yg dibayar",
                    sortable: true
                },
                {
                    key: "nilaibyr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kasdiskon",
                    label: "Settlement NON Bank/Cash",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:120px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },

            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        arpaymdtObj:{invdate:'', kodecash:'',IDPotongan:'', kasdiskon:'', nilaibank:'', nilaibyr:'', custinfo:'', custcode:'', customerid:''},
        infoDPP:'',
        monthLabels: dropdown.monthLabels,
        lkuArinvShow: false,
        lkuCustomerShow:false,
        tabIndex:0
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArpaymdt() {
      this.$v.arpaymdtObj.$touch();
      return this.$v.arpaymdtObj.$invalid;
    },
    caraBayar(){
        return this.model.jenis;
    },
    bankkas(){
        return this.model.kodebank;
    },
    adaPotongan(){
        return ((this.arpaymdtObj.kasdiskon || 0) != 0);
    },
    IDPotongan(){return this.arpaymdtObj.IDPotongan;},
    adaNilaiBank(){return ((this.arpaymdtObj.nilaibank || 0) != 0);},
  },
  watch: {
    bankkas: function(kode) {
            if (this.uanguser.trim() == this.model.matauang.trim()) {
                this.model.kurstrx = 1;
            }
    },    
    IDPotongan: function(kode) {
        let pot = this.potongans.find(r => r.value===kode);
        if (pot){
            this.arpaymdtObj.Potongan=pot.text;
        }
    },    
  },
  created: async function(){
      this.model.matauang=this.uanguser;
      if (this.$route.params.arpaymKey) {
          toastr.info('Loading Payment Detail, please wait')
          try {

            // const data = await arpayment.arpaymdetail(this.$route.params);  
            const [a,c,d,e,data] = await Promise.all([arpayment.currency(),await arpayment.argroup(),await arpayment.potongan(),
                                    crud.list({tablename: "vwcollector",page: 1,limit: 1000,sortBy: "collector_name",sortDesc: false}),
                                    arpayment.arpaymdetail(this.$route.params)]) ;
            this.currency = a;
            this.arGroups = c;
            this.potongans = d;
            this.collectors = e.reduce((newArr,item) =>{
                newArr.push({ value: item.collector_id, text: item.collector_name});
                return newArr;
            },[]);            
            const row = data[0][0];
            this.saveEnabled=(row.statusar === 0);
            row.tglpaym = row.tglpaym ? moment(row.tglpaym).format('YYYY-MM-DD') : '';
            row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
            row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.arpaymdt.items = data[1];
            this.arpaymdt.total=this.arpaymdt.items.length;
            this.calcTotalDtlPaym();
            this.updateDimHdr = !this.updateDimHdr;
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        const [a,c,d,e] = await Promise.all([arpayment.currency(),await arpayment.argroup(),await arpayment.potongan(),
                        crud.list({tablename: "vwcollector",page: 1,limit: 1000,sortBy: "collector_name",sortDesc: false})]) ;
        this.currency = a;
        this.arGroups = c;
        this.potongans = d;
            this.collectors = e.reduce((newArr,item) =>{
                newArr.push({ value: item.collector_id, text: item.collector_name});
                return newArr;
            },[]);            

      }
  },
  methods: {
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        this.arpaymdtObj.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        this.arpaymdtObj.kodecash = lkuData.selected.kodecash;
        this.arpaymdtObj.namacash = lkuData.selected.namacash;
        this.lkuCashflowShow=false;
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if ((opened) && (opened.invdate)) {
            toastr.warn('Line/Detail Form Un Saved');
            this.saveEnabled=true;            
            return;
        }
        
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else if (this.totalDtlPaym > parseFloat(this.model.totalbyr)) {
            toastr.error('[Transaction Amount] not Balance with [Total Detail Payment]', "ERROR MESSAGE");
        } else {
            if (parseFloat(this.model.totalbyr)>this.totalDtlPaym) {
                toastr.warn('[Total Payment Header] is greter than [Total Payment Detail]');
            }            
            // this.model.TableName = 'arpaymtt';
            try {
                // const dimValResult = await dimension.validate(this.model);
                // if (dimValResult.success) {
                    this.model.paymno = this.model.paymno || '';
                    this.model.statusar = this.model.statusar || 0;
                    this.model.statustre = this.model.statustre || 0;
                    this.model.totalbyr = this.model.totalbyr || 0;
                    this.model.bcharge = this.model.bcharge || 0;

                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tglpaym = moment(row.tglpaym).format('YYYY-MM-DD');
                    row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : undefined;
                    row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : moment(row.tglpaym).format('YYYY-MM-DD');
                    let settl_amt=0;
                    let newArpaymdts = this.arpaymdt.items.reduce((newArr, item) => {
                        if ((item.invdate || '') != '') {
                            item.invdate = moment(item.invdate).endOf('month').format('YYYY-MM-DD');
                            // if (((item.nilaibyr || 0)+(item.kasdiskon || 0)) != 0) {
                            //     newArr.push(item);
                            // }
                            // item.kurspost = this.model.kurstrx;
                            settl_amt += item.nilaibank;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    this.model.settl_amt=settl_amt;
                    row.settl_amt=settl_amt;

                    newArpaymdts.sort((a, b) => {   
                            if ( a.customerid < b.customerid ){
                                return -1;
                            }
                            if ( a.customerid > b.customerid ){
                                return 1;
                            }
                            return 0;
                        });
                    row.arpaymdt = newArpaymdts;
                    await arpayment.insert(row);
                    toastr.success("Complete successfully", "Save Receipt");
                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.saveEnabled=true;            
                        const jenis = this.model.jenis;
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        this.model.jenis = jenis;
                        this.model.matauang= this.$store.state.user.matauang;
                        this.model.kurstrx=1;
                        this.model.settl_amt= 0;
                        this.model.tglpaym = moment().format('YYYY-MM-DD');
                        this.totalDtlPaym=0;
                        for (var key in this.arpaymdtObj) {
                            this.arpaymdtObj[key] = '';
                        }
                        this.arpaymdt.items = [];
                        this.arpaymdt.total=0;
                        this.calcTotalDtlPaym();
                        this.$v.model.$reset();
                    }
                // } else {
                //     this.saveEnabled=true;            
                //     console.log('dimValResult : ', dimValResult);
                //     var msg = dimValResult.message || 'Dimension validation error';
                //     toastr.error(msg, "ERROR MESSAGE");
                // }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    closeArPayment: function(){
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addArpaymdt : function () {
        let goAhead=true;
        if (this.model.totalbyr) {
            if ((this.model.totalbyr - this.totalDtlPaym)<0) {
                goAhead=false;
            }
        }

        if (goAhead==true) {
            this.closeArPayment();
            const obj={_showDetails:true};
            this.arpaymdt.selected = obj;
            for (var key in this.arpaymdtObj) {
                this.arpaymdtObj[key] = '';
            }
            this.arpaymdtObj.kurskeAR=1;
            this.tabIndex = 0;
            this.arpaymdt.items.push(obj);
            this.arpaymdt.total=this.arpaymdt.items.length;
            setTimeout(() => {
                const bfore = this.arpaymdt.page;
                const after =Math.ceil((this.arpaymdt.total)/this.arpaymdt.limit);
                if (bfore != after){
                    this.arpaymdt.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.arpaymdt.total} items`,'Line/Detail',10000);
                }
                 
            }, 100);    
        } else {
            toastr.error('UnSettled Amount can not be zero or less');
        }
    },
    editArpaymdt : function (obj,callback) {
        this.closeArPayment();
        this.arpaymdt.selected = obj;
        for (var key in this.arpaymdtObj) {
            this.arpaymdtObj[key] = '';
        }
        for (var key in obj) {
            this.arpaymdtObj[key] = obj[key];
        }
        setTimeout(() => {
            this.tabIndex = (this.adaNilaiBank) ? 0:1;            
        }, 200);
        callback();
    },
    delArpaymdt: function (index) {
        if (index > -1) {
            // this.arpaymdt.items.splice(index, 1);
            const posisi = (this.arpaymdt.page-1)*this.arpaymdt.limit;
            this.arpaymdt.items.splice(posisi+index, 1);
        }
        this.arpaymdt.total=this.arpaymdt.items.length;
        this.calcTotalDtlPaym();
    },
    updateNilaibank: function() {
        if (this.model.matauang==this.arpaymdtObj.matauang)
        {
            this.arpaymdtObj.nilaibank=this.arpaymdtObj.nilaibyr;
            this.arpaymdtObj.kurskeAR = 1;
            // this.arpaymdtObj.selisihkurs = 0;
        }
    },
    saveArpaymdt: function (callback) {
        if (!this.adaPotongan) this.arpaymdtObj.IDPotongan='';
        this.arpaymdtObj.nilaibyr = this.arpaymdtObj.nilaibyr || 0;
        this.arpaymdtObj.kasdiskon = this.arpaymdtObj.kasdiskon || 0;
                
        if (this.invalidArpaymdt) {
            console.log('validation : ', this.$v.arpaymdtObj);
            console.log('model obj : ',this.arpaymdtObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            this.arpaymdtObj.selisihkurs = 0;
            this.arpaymdtObj.invdate=arpaymdtObj.invdate
            for (var key in this.arpaymdtObj) {
                this.arpaymdt.selected[key] = this.arpaymdtObj[key];
            }                
            // this.arpaymdt.selected.invdate=moment(this.arpaymdtObj.invdate).endOf('month').format('YYYY-MM-DD');
            this.calcTotalDtlPaym();
            this.arpaymdt.selected._showDetails=false;
            if (callback) callback();
            if (this.inputLineBerlanjut==1) {
                this.addArpaymdt();
                this.$v.arpaymdtObj.$reset();
            }

        }
    },

    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.model.kodebank=lkuData.selected.kode;
        this.model.matauang=lkuData.selected.matauang;
        this.model.namabank=lkuData.selected.namabank;
        this.model.nomorrek=lkuData.selected.nomorrek;
        this.model.isbank=lkuData.selected.isbank;
        this.lkuBankaccountShow=false;
    },
    calcPotongan : function() {
        let pot = this.potongans.find(r => r.value=== this.arpaymdtObj.IDPotongan);
        if (pot){
            if (pot.pajak) {
                this.arpaymdtObj.kasdiskon = this.arpaymdtObj.nilaidpp * this.arpaymdtObj.tarif / 100;
            } else {
                this.arpaymdtObj.kasdiskon = this.arpaymdtObj.totalinv * this.arpaymdtObj.tarif / 100;
            }
        } else {
            this.arpaymdtObj.kasdiskon = this.arpaymdtObj.totalinv * this.arpaymdtObj.tarif / 100;
        }
    },

    onSelectLkuCustomer: async function (_selected) {
        // this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        // this.model.custcode = _selected.CustCode;
        // this.model.CustName = _selected.CustName;
        // this.model.customer_id = _selected.customer_id;
        // this.model.collector_id= _selected.collector;
        this.arpaymdtObj.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.arpaymdtObj.custcode = _selected.CustCode;
        this.arpaymdtObj.CustName = _selected.CustName;
        this.arpaymdtObj.customerid = _selected.customer_id;
        this.arpaymdtObj.collector_id= _selected.collector;
        this.lkuCustomerShow=false;
    },

    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.othPayment.obj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
        let totalDtlPaym = this.model.bcharge || 0;
        totalDtlPaym = totalDtlPaym || 0;
        this.arpaymdt.items.forEach( function (trx) {
            if (trx.invdate) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        });
        this.totalDtlPaym = totalDtlPaym;
    },
    close(){
        router.push({name:'koran.paymgabungan'});
    }
  }
};
</script>
